import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import React from "react";
import { MONTHDAY_OPTIONS, WEEKDAY_OPTIONS } from "../utils/taskSchedule";

function renderJoinedLabels(values, options) {
  return values
    .map((value) => options.find((option) => option.value === value)?.label)
    .filter(Boolean)
    .join("・");
}

function SelectOptions({ options, selectedValues, onChange, label, labelId, disabled }) {
  const theme = useTheme();

  return (
    <FormControl size="small" fullWidth disabled={disabled}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        multiple
        value={selectedValues}
        label={label}
        onChange={(event) =>
          onChange([...event.target.value].map(Number).sort((a, b) => a - b))
        }
        renderValue={(selected) => renderJoinedLabels(selected, options)}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{
              "&.Mui-selected": {
                backgroundColor: alpha(theme.palette.primary.main, 0.18),
              },
              "&.Mui-selected:hover": {
                backgroundColor: alpha(theme.palette.primary.main, 0.24),
              },
            }}
          >
            <Checkbox
              checked={selectedValues.includes(option.value)}
              size="small"
              sx={{ mr: 1, py: 0.25 }}
            />
            <ListItemText
              primary={label === "曜日" ? `${option.label}曜日` : option.label}
              primaryTypographyProps={{
                fontWeight: selectedValues.includes(option.value) ? 700 : 400,
                color: selectedValues.includes(option.value)
                  ? "primary.main"
                  : "text.primary",
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

function RecurrenceFields({
  idPrefix,
  recurrenceType,
  weeklyDays = [],
  monthlyDays = [],
  onRecurrenceTypeChange,
  onWeeklyDaysChange,
  onMonthlyDaysChange,
  disabled = false,
}) {
  return (
    <>
      <FormControl size="small" fullWidth disabled={disabled}>
        <InputLabel id={`${idPrefix}-recurrence-type-label`}>繰り返し</InputLabel>
        <Select
          labelId={`${idPrefix}-recurrence-type-label`}
          value={recurrenceType}
          label="繰り返し"
          onChange={(event) => onRecurrenceTypeChange(event.target.value)}
        >
          <MenuItem value="daily">毎日</MenuItem>
          <MenuItem value="weekly">毎週</MenuItem>
          <MenuItem value="monthly">毎月</MenuItem>
        </Select>
      </FormControl>
      {recurrenceType === "weekly" && (
        <SelectOptions
          labelId={`${idPrefix}-weekly-days-label`}
          label="曜日"
          options={WEEKDAY_OPTIONS}
          selectedValues={weeklyDays}
          onChange={onWeeklyDaysChange}
          disabled={disabled}
        />
      )}
      {recurrenceType === "monthly" && (
        <SelectOptions
          labelId={`${idPrefix}-monthly-days-label`}
          label="日付"
          options={MONTHDAY_OPTIONS}
          selectedValues={monthlyDays}
          onChange={onMonthlyDaysChange}
          disabled={disabled}
        />
      )}
    </>
  );
}

export default RecurrenceFields;
